<div class="section">
  <div class="caption">Account</div>
  <div class="caption">
    <div class="amount">Amount</div>
  </div>
</div>
